(function(){
    'use strict'; 
    angular.module('Filters').filter('bbaRange', function(){
        return function(input, total){
            total = parseInt(total); 
            for(var i = 1; i <= total; i++) {
                input.push(i);
            }
            return input;
        }
    });
})();


// WEBPACK FOOTER //
// ./js/filters/bbaRange.js